import HomePage from "./components/Pages/Homepage/Homepage";

const App = () => <HomePage />;

export default App;
